import { apiErrorStatus } from './api-response-helper/api-response-helper';

/** TanStack `retry`: a 4xx is the API's final word, except 408/429, which are transient. Everything else (5xx, network) is retried up to `maxRetries`. */
export function retryUnlessClientError(maxRetries: number) {
    return (failureCount: number, error: unknown): boolean => {
        const status = apiErrorStatus(error);

        const isFinal = status !== undefined && status >= 400 && status < 500 && status !== 408 && status !== 429;

        return !isFinal && failureCount < maxRetries;
    };
}
